import { render, staticRenderFns } from "./GridCheckboxColumn.vue?vue&type=template&id=913da5a6&"
import script from "./GridCheckboxColumn.vue?vue&type=script&lang=ts&"
export * from "./GridCheckboxColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports